import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export function CategoriesSection() {
  const colorMap: Record<string, { bg: string; border: string; icon: string; text: string }> = {
    accent: { bg: 'bg-accent-50', border: 'border-accent-200/60', icon: 'text-accent-600', text: 'text-accent-700' },
    primary: { bg: 'bg-primary-50', border: 'border-primary-200/60', icon: 'text-primary-600', text: 'text-primary-700' },
    secondary: { bg: 'bg-secondary-50', border: 'border-secondary-200/60', icon: 'text-secondary-600', text: 'text-secondary-700' },
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            内容分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-lg mx-auto">
            按分类浏览内容，快速找到您需要的使用指南和教程
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => {
            const c = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="bg-background-50 rounded-xl border border-background-200/70 p-6 hover:border-background-300/60 transition-all duration-200 group cursor-pointer"
              >
                <div className={`w-12 h-12 ${c.bg} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${cat.icon} ${c.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {cat.articleCount} 篇文章
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}